function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
function _object_without_properties(source, excluded) {
    if (source == null) return {};
    var target = _object_without_properties_loose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function _object_without_properties_loose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
import classnames from 'classnames';
import React from 'react';
import { FormCheck } from 'react-bootstrap';
var Checkbox = function(props) {
    var id = props.id, label = props.label, children = props.children, disabled = props.disabled, labelClass = props.labelClass, rest = _object_without_properties(props, [
        "id",
        "label",
        "children",
        "disabled",
        "labelClass"
    ]);
    return /*#__PURE__*/ React.createElement(FormCheck, {
        bsPrefix: "Checkbox"
    }, /*#__PURE__*/ React.createElement(FormCheck.Input, _object_spread({
        id: id,
        disabled: disabled,
        type: "checkbox"
    }, rest)), /*#__PURE__*/ React.createElement(FormCheck.Label, {
        className: classnames(_define_property({
            disabled: disabled
        }, labelClass, labelClass)),
        htmlFor: id
    }, label || children));
};
export default Checkbox;
